import {
  useStyle 
} from "@/classify"
import {
  useIntl 
} from "react-intl"
import defaultClasses from "./trigger.module.css"

const Trigger = (props) => {
  const {
    addLabel,
    action,
    children,
    classes: propClasses,
    ...restProps
  } = props
  const classes = useStyle(defaultClasses, propClasses)

  const {
    formatMessage 
  } = useIntl()
  const arialabelClear = formatMessage({
    id: "global.clearText",
    defaultMessage: "Clear Text",
  })

  const arialabelClose = formatMessage({
    id: "global.close",
    defaultMessage: "Close",
  })

  let resultedLabel = addLabel ? arialabelClear : arialabelClose

  const handleKeypress = () => {
    action()
    resultedLabel = ""
  }

  const changeAction = (e) => {
    if (e.keyCode === 13) {
      action()
    }
  }

  return (
    <button
      className={classes.root}
      type='button'
      onClick={handleKeypress}
      onKeyDown={changeAction}
      aria-hidden='false'
      aria-label={resultedLabel}
      {...restProps}
    >
      {children}
    </button>
  )
}

export default Trigger
